import Clarity from "@microsoft/clarity";
import { jwtDecode } from "jwt-decode";
import { useEffect, useState } from "react";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";
import { EXTERNAL_LOGIN_URL } from "../../../consts";
import { authByIp, loginDependentUser } from "../../../services";
import { loginWithToken } from "../../../store/reducer/_sessionReducer";
import { getLoggedIn } from "../../../store/selectors";
import { getIsIpDomain } from "../../../utils";
import { Copyright, LoginForm, Pagewrapper } from "../../components";
import { PDLTypography } from "../../components/dna";
import SimultaneousAccessModal from "../../components/global/_simultaneosAccessModal";

import "./index.scss";

const Login = (props) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const [simultaneousErrorCode, setSimultaneousErrorCode] = useState(null);

  const isIpDomain = getIsIpDomain();
  const loggedIn = useSelector(getLoggedIn);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleClarityAndSaveToken = (token) => {
    const decoded = jwtDecode(token);

    const user = {
      name: decoded.name,
      email: decoded.email,
      origem: decoded.type,
      idPessoa: decoded.userId,
    };

    Clarity.identify(String(decoded.userId));
    Clarity.setTag("user_email", decoded.email);
    Clarity.setTag("user_origin", decoded.type);

    dispatch(
      loginWithToken({
        user,
        token,
      }),
    );

    navigate("/home", { replace: true });
  };

  const handleLogin = async (email, password) => {
    try {
      setLoading(true);
      const { token } = await loginDependentUser(email, password);
      handleClarityAndSaveToken(token);
    } catch (error) {
      const data = error?.response?.data;

      if (data?.simultaneousError) {
        setSimultaneousErrorCode(data.code);
        return;
      }

      setError(data?.message || "Erro ao fazer login");
    } finally {
      setLoading(false);
    }
  };

  const handleAuthByIp = async () => {
    try {
      const { token } = await authByIp();

      handleClarityAndSaveToken(token);
    } catch (error) {
      const data = error?.response?.data;

      if (data?.simultaneousError) {
        setSimultaneousErrorCode(data.code);
        return;
      }

      if (data?.message) {
        setError(data.message);
      }
    }
  };

  useEffect(() => {
    if (!isIpDomain) {
      window.location.href = EXTERNAL_LOGIN_URL;
    } else if (!loggedIn) {
      handleAuthByIp();
    }
  }, []);

  return (
    <>
      {" "}
      <Pagewrapper {...props}>
        <Container fluid className="pdl_page_login">
          <Row className="h-100">
            <Col sm={6} className="h-100 pdl_page_login_column_left">
              <Container className="h-100 d-flex flex-column align-items-center justify-content-between">
                <Row></Row>
                <Row className="pdl_page_login_form_container">
                  <Col>
                    <LoginForm onSubmit={handleLogin} loading={loading} />
                    {error && <p className="form_error mt-3">{error}</p>}
                  </Col>
                </Row>
                <Row className="w-100">
                  <Col className="py-3 justify-self-stretch">
                    <Copyright />
                  </Col>
                </Row>
              </Container>
            </Col>
            <Col
              sm={6}
              className="h-100 pdl_page_login_column_right d-none d-sm-block"
            >
              <Container className="h-100 p-0 m-0 d-flex flex-column align-items-center justify-content-center">
                <Row>
                  <Col className="pdl_page_login_column_right_contents p-0 m-0 text-center d-grid gap-5">
                    <img
                      alt="Plataforma LEX"
                      className="pdl_page_login_image_plataforma rounded"
                      src="/images/generic/plataforma_lex.png"
                    />
                    <div className="d-grid gap-2">
                      <PDLTypography size="xl" variant="light" weight="medium">
                        Boas vindas à Plataforma LEX
                      </PDLTypography>
                      <PDLTypography size="md" variant="light" weight="medium">
                        Sua fonte central de pesquisa jurídica, com conteúdos
                        confiáveis e atualizados.
                      </PDLTypography>
                    </div>
                  </Col>
                </Row>
              </Container>
            </Col>
          </Row>
        </Container>
      </Pagewrapper>{" "}
      <SimultaneousAccessModal
        show={!!simultaneousErrorCode}
        code={simultaneousErrorCode}
        onHide={() => setSimultaneousErrorCode(null)}
      />
    </>
  );
};

export default Login;
